import { strapiApiSlice } from '../../app/api/strapiApiSlice'
import { queryString } from '../../utils/queryString'

const strapiSlice = strapiApiSlice.injectEndpoints({
  endpoints: build => ({
    getAboutUs: build.query<any, void>({
      query: () => '/about-us',
    }),
    getHowToTrade: build.query<any, void>({
      query: () => '/how-to-trade',
    }),
    getBlogs: build.query<any, { page?: number; pageSize?: number }>({
      query: ({ page = 1, pageSize = 5 }) => {
        return `/blogs?sort[0]=createdAt:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=*`
      },

      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Blogs' as const,
                id: _id,
              })),
              { type: 'Blogs', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Blogs', id: 'PARTIAL-LIST' }],
    }),
    getBlogsById: build.query<any, { id: string }>({
      query: ({ id }) => `/blogs/${id}?populate=*`,
    }),

    getFaqs: build.query<any, void>({
      query: () => '/faqs',
    }),

    getTestimonials: build.query<any, void>({
      query: () => '/testimonials',
    }),

    getAnnouncement: build.query<any, { page?: number; pageSize?: number }>({
      query: ({ page = 1, pageSize = 10 }) =>
        `/announcements?sort[0]=createdAt:desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}`,
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Announcements' as const,
                id: _id,
              })),
              { type: 'Announcements', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Announcements', id: 'PARTIAL-LIST' }],
    }),
    getBanners: build.query<any, void>({
      query: () => '/banners?populate=*',
    }),
  }),
})

export const {
  useGetAboutUsQuery,
  useGetHowToTradeQuery,
  useGetBlogsQuery,
  useGetBlogsByIdQuery,
  useGetFaqsQuery,
  useGetTestimonialsQuery,
  useGetAnnouncementQuery,
  useGetBannersQuery,
} = strapiSlice
